export function useTalkToRecruiterCopyText() {
  return {
    banner: {
      screening: "Talk to a Clipboard recruiter to unlock listings with instant interviews",
      screeningAction: "Book my call",
      upskilling: "Complete your coaching call to unlock Instant Interviews",
      upskillingAction: "Schedule now",
    },
    id: "unlock-instant-interviews",
    placementAction: {
      screening: "Unlock instant interviews",
      screeningDescription: "",
      upskilling: "Complete coaching session",
      upskillingDescription:
        "A 30 minute private coaching session about acing your interview. You'll need to complete this course to unlock instant interviews",
    },
  };
}

export type TalkToRecruiterCopy = ReturnType<typeof useTalkToRecruiterCopyText>;
